import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CustomerPartNumberModel, UserDetailsModel } from "@tCooneyBrothers/ApiModels";
import UserDetailsState from "@tCooneyBrothers/Store/Data/UserDetails/UserDetailsState";
import { Draft } from "immer";

const initialState: UserDetailsState = {
    isLoading: false,
    value: [],
};

const reducer = {
    "Data/UserDetails/BeginLoadUserDetails": (draft: Draft<UserDetailsState>) => {
        draft = {
            isLoading: true,
        };
    },
    "Data/UserDetails/CompleteLoadUserDetails": (
        draft: Draft<UserDetailsState>,
        action: { result: UserDetailsModel[] },
    ) => {
        draft = {
            isLoading: false,
            value: initialState.value?.concat(action.result),
        };
        return draft;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
